import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const FormSectionTitle = styled(Typography)`
  ${({ required }) =>
    required
      ? `:after {
        content: "*";
        color: red;
        margin-left: 3px;
      }`
      : ""}
`;
